export default "__VITE_ASSET__d4d26c3a__"